import { Dictionary } from 'lodash';

export type GettingStarted<T = Date> = {
  completedTasks: Dictionary<T>;
};

export type BaseUserInfo<T> = {
  gettingStarted: GettingStarted<T>;
};

export const INITIAL_USER_INFO: BaseUserInfo<number> = {
  gettingStarted: {
    completedTasks: {},
  },
};
export interface UserInfo<T = Date> extends BaseUserInfo<T> {
  userId: string;
}

export type CompleteGettingStartedTaskPayload = {
  userId: string;
  taskName: string;
  completedOn: Date;
};
